import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditProperty from "../components/EditProperty"

const EditPropertyPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Edit Property' />

        <EditProperty />

      </MasterLayout>
    </>
  );
};

export default EditPropertyPage;
